import React from "react";
import DataTable from "../Reusable/DataTable/UserDataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";
import SwitchButton from "../Reusable/SwitchButton";
import AccessControl from "../../helpers/acessControl";

const StaffList = (props: any) => {
  const { handleIsActive } = props
  const defaultColumns: any = [
    {
      header: "Full Name",
      accessorKey: "profile.full_name",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "email",
      cell: NACell,
    },
    {
      header: "Mobile Number",
      accessorKey: "mobile_number",
      cell: NACell,
    },
    {
      header: "Role/Group",
      accessorKey: "designation",
      cell: NACell,
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <AccessControl children={<SwitchButton
          id={row?.original?.id}
          value={getValue()}
          disabled={false}
          onChange={handleIsActive}
        />}
          allowedPermissions={["can_update_user"]}
          renderNoAccess={<SwitchButton
            id={row?.original?.id}
            value={getValue()}
            disabled={true}
            onChange={handleIsActive}
          />}
        />
      )
    },

    {
      header: "Action",
      accessorKey: "id",
      cell: ({ row, getValue }: any) => (
        <>
          <TableActionButton editPath={`/users/edit/${getValue()}`} />
        </>
      ),
    },
  ];

  return (
    <>
      <DataTable
        url={APIS.USER}
        queryKey={"users"}
        params={{ is_staff: true }}
        columns={defaultColumns}
        addNewPagePath={""}
        tableName={"Staff"}
      />
    </>
  );
};

export default StaffList;
